import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DesabonnementService {

  constructor(private http: HttpClient) {
  }

  getDesabonnement(email: any, sujet: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/api/desabonnement`,
      {email, sujet}
    );
  }
}
